export var fundTypes = [
    {
        name: "Demat",
        description: " Mutual fund units are held electronically in your demat account. You can track, invest, and view statements online.",
    },
    {
        name: "Physical",
        description: " Mutual fund units are held by RTAs and backed by a Statement of Account (SOA). Track, view reports, and transact online.",
    },
];
export var schemeReturnType = [
    {
        name: "Growth",
        description: " Profits made by the scheme are invested back into it and this results in the NAV rising over time.",
    },
    {
        name: "Dividend-Payout",
        description: " You will get regular payouts as and when dividends are declared.",
    },
    {
        name: "Dividend-Reinvest",
        description: " As and when the dividends are received, they will be reinvested and you will get more units of the same fund.",
    },
];
